import { render, staticRenderFns } from "./Basico.vue?vue&type=template&id=8388694c"
import script from "./Basico.vue?vue&type=script&lang=js"
export * from "./Basico.vue?vue&type=script&lang=js"
import style0 from "./Basico.vue?vue&type=style&index=0&id=8388694c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports